module.exports = __webpack_public_path__ + "static/sm_img06@2x-3d3f94b3b3f411ba7e57e77b2af147c0.jpg";